import { render, staticRenderFns } from "./InvoiceModal.vue?vue&type=template&id=63c36d8e&scoped=true&"
import script from "./InvoiceModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceModal.vue?vue&type=style&index=0&id=63c36d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c36d8e",
  null
  
)

export default component.exports